import { useAuth } from 'utils/hooks/useAuth'
import { useSalesNetwork } from 'utils/hooks/useSalesNetworks'
import useTranslation from 'utils/hooks/useTranslation'
import mainBackground from '../assets/img/background_1920.jpg'
import mainBackgroundThermor from '../assets/img/background_thermor_1920.jpg'
import { SvgAdd, SvgSetting } from 'components/svg'

import { useNavigate } from 'react-router-dom'
import { LoginAzureAd } from 'components/LoginWidget'
import { APP_URL, getAppUrl } from 'utils/defines'
import { useProject } from 'utils/hooks/useProject'
import { useEffect } from 'react'
import { useAppSelector } from 'store/hooks'
import { writeDataLayer } from 'utils/helpers'

export const HomePage: React.FC = () => {
  const { isAuth } = useAuth()
  const { t, tHtml, convertToHtml } = useTranslation()
  const { network, isThermor } = useSalesNetwork()
  const navigate = useNavigate()
  const { initNewProject } = useProject()
  const authState = useAppSelector((state) => state.auth)

  useEffect(() => {
    writeDataLayer('home', authState)
  }, [])

  const newProject = () => {
    navigate(getAppUrl('/project/home/heat'), { replace: true })

    initNewProject()
  }

  const MyProjects = () => {
    navigate(getAppUrl(APP_URL.MyProjects), { replace: true })
  }

  return (
    <group data-height="auto" data-min-height="fit">
      <picture data-position="absolute" data-object-fit="cover">
        <img src={isThermor ? mainBackgroundThermor : mainBackground} alt="" />
      </picture>
      {/* <group data-align="center" data-direction="column" data-gap="20" data-adaptive="desktop">

        <group data-gap="40" data-wrap="no" data-max-length="1200">
          <group data-gap="20" data-direction="column">
            <group
              data-type="grid"
              data-grid-template="300"
              data-gap="20"
              data-name="main-thumbnail"
            >
              {isLoading && <Loader />}
            </group>
          </group>

        </group>
      </group> */}

      {!isAuth ? (
        <>
          <group data-direction="column" data-justify="center" data-align="center" data-adaptive="desktop">
            <group
              data-background="main"
              data-radius="20"
              data-radius-bottom-left="0"
              data-radius-bottom-right="0"
              data-space="30"
              data-min-length="240"
              data-length="450"
              data-height="300"
              data-contain=""
              data-direction="column"
              data-align="center"
              data-justify="center"
              data-gap="20"
              data-dark=""
              data-position="absolute"
              data-right="100"
            //data-bottom="100"
            >
              <group data-gap="10" data-align="center">
                <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                  {t('WELCOME_TITLE')}
                </text>
              </group>

              <text data-wrap="wrap" data-line="1.5">
                {t('HOME_WELCOME_TEXT')}
              </text>
            </group>
          </group>

          <group data-direction="column" data-justify="center" data-align="center" data-adaptive="mobile">
            <group
              data-background="main"
              data-radius="20"
              data-radius-bottom-left="0"
              data-radius-bottom-right="0"
              data-space="30"
              data-min-length="240"
              data-length="450"
              data-height="300"
              data-contain=""
              data-direction="column"
              data-align="center"
              data-justify="center"
              data-gap="20"
              data-dark=""
            //data-position="absolute"
            //data-right="100"
            //data-bottom="100"
            >
              <group data-gap="10" data-align="center">
                <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                  {t('WELCOME_TITLE')}
                </text>
              </group>

              <text data-wrap="wrap" data-line="1.5">
                {t('HOME_WELCOME_TEXT')}
              </text>
            </group>
          </group>
        </>
      ) : (
        <>
          <group data-space="20" data-align="center" data-adaptive="desktop">
            <group
              data-gap="30"
              //data-wrap="no"
              data-justify="center"
              data-align="center"
            >
              {network?._parameters.INFORMATION && (
                <group
                  data-background="main"
                  data-radius="20"
                  data-radius-bottom-left="0"
                  data-radius-bottom-right="0"
                  data-space="30"
                  data-min-length="240"
                  data-length="500"
                  data-min-height="300"
                  data-contain=""
                  data-direction="column"
                  data-wrap="no"
                  data-align="center"
                  data-justify="center"
                  data-gap="20"
                  data-dark=""
                >
                  <group data-gap="10" data-align="center">
                    <icon data-icon-size="medium">info</icon>
                    <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                      Information
                    </text>
                  </group>
                  <group data-opacity="80" data-direction="column" data-space="10" data-gap="5">
                    {convertToHtml(network?._parameters.INFORMATION || '')}
                  </group>
                </group>
              )}

              <group
                data-background="main-color-custom-light"
                data-radius="extra-special"
                data-height="300"
                data-contain=""
                data-length="280"
                data-min-length="240"
                data-cursor="pointer"
                data-interactive=""
                onClick={newProject}
              >
                <group data-space="20" data-direction="column" data-align="center" data-justify="center">
                  <icon data-icon-size="large" data-svg-color="main" data-length="40">
                    <SvgAdd />
                  </icon>
                  <group data-opacity="80" data-weight="700" data-text-size="22" data-direction="column" data-align="center">
                    {tHtml('HOME_NEW_PROJECT')}
                  </group>
                </group>
              </group>
              <group
                data-background="main-color-custom-light"
                data-radius="extra-special"
                data-height="300"
                data-contain=""
                data-length="280"
                data-min-length="240"
                data-cursor="pointer"
                data-interactive=""
                onClick={MyProjects}
              >
                <group data-space="20" data-direction="column" data-align="center" data-justify="center">
                  <icon data-icon-size="large" data-svg-color="main" data-length="40">
                    <SvgSetting />
                  </icon>
                  <group data-opacity="80" data-weight="700" data-text-size="22" data-direction="column" data-align="center">
                    {tHtml('HOME_MY_PROJECTS')}
                  </group>
                </group>
              </group>
            </group>
          </group>

          {network?._parameters.INFORMATION && (
            <group
              //data-space="20"
              //data-gap="30"
              data-wrap="no"
              data-justify="center"
              data-adaptive="mobile"
            >
              <group
                data-background="main"
                //data-radius="20"
                //data-radius-bottom-left="0"
                //data-radius-bottom-right="0"
                data-space="30"
                data-min-length="240"
                //data-length="500"
                data-min-height="130"
                data-contain=""
                data-direction="column"
                data-wrap="no"
                //data-align="center"
                //data-justify="center"
                data-gap="10"
                data-dark=""
              >
                <group data-gap="10" data-align="center">
                  <icon data-icon-size="medium">info</icon>
                  <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                    Information
                  </text>
                </group>
                <group data-opacity="80" data-direction="column" data-space="10" data-gap="5">
                  {convertToHtml(network?._parameters.INFORMATION || '')}
                </group>
              </group>
            </group>
          )}

          <group
            data-space="20"
            data-gap="20"
            //data-wrap="no"
            //data-justify="center"
            data-adaptive="mobile"
            data-direction='column'
          >

            <group
              data-background="main-color-custom-light"
              data-radius="extra-special"
              data-height="100"
              data-contain=""
              data-length="fit"
              data-cursor="pointer"
              data-interactive=""
              onClick={newProject}
            >
              <group data-space="20" data-gap="20" data-wrap="nowrap" data-align="center" data-justify="center">
                <icon data-icon-size="large" data-svg-color="main" data-length="40">
                  <SvgAdd />
                </icon>
                <group data-opacity="80" data-weight="700" data-text-size="22" data-width="auto" data-max-length='180' data-align="center">
                  {tHtml('HOME_NEW_PROJECT')}
                </group>
              </group>
            </group>
            <group
              data-background="main-color-custom-light"
              data-radius="extra-special"
              data-height="100"
              data-contain=""
              data-length="fit"
              data-cursor="pointer"
              data-interactive=""
              onClick={MyProjects}
            >
              <group data-space="20" data-gap="20" data-wrap="nowrap" data-align="center" data-justify="center">
                <icon data-icon-size="large" data-svg-color="main" data-length="40">
                  <SvgSetting />
                </icon>
                <group data-opacity="80" data-weight="700" data-text-size="22" data-width="auto" data-max-length='180' data-align="center">
                  {tHtml('HOME_MY_PROJECTS')}
                </group>
              </group>
            </group>

          </group>
        </>
      )}

      {!isAuth && <LoginAzureAd />}
    </group>
  )
}
